<script>
	import { onMount } from "svelte";
	import { individualInvoicesState } from "../../state/ApplicationState.svelte";	
	import { FormGroup, Input, Modal, ModalHeader, ModalBody, } from "@sveltestrap/sveltestrap";
	import { debouncePromise, baseUrl, getDateFormatter, isValidDate, } from "../../../../../SharedSvelte/Common.svelte";
	import { Loader } from "../../../../../SharedSvelte/GlobalLoader.svelte";
	import { IndividualInvoiceRecord } from "./IndividualInvoiceRecord.svelte";

	let errors = $state({});
	let isQueryComplete = $state(false);
	let loadError = $state("");

	const loadIndividualInvoices = async () => {
		//console.log("load individual invoices");
		isQueryComplete = false;
		Loader.display();
		individualInvoicesState.invoicesList = [];
		loadError = "";

		try {
			
			const payload = {
				beginningDate: individualInvoicesState.beginningDate,
				endingDate: individualInvoicesState.endingDate,
			};
			
			//console.log(payload);
			const isValid = Object.values(payload).every(v => v != null); // true if none are null or undefined
			if (!isValid) return null;

			const response = await fetch(
				`${baseUrl}Options/IndividualInvoices/QueryInvoices`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						__RequestVerificationToken: document.getElementsByName("__RequestVerificationToken")[0].value
					},
					body: JSON.stringify(payload),
				},
			);
			if (!response.ok) {
				const error = `Server exception: ${response.status} ${response.statusText}`;
				console.log(error);
				throw new Error();
			}

			const json = await response.json();
			if (!json.success) {
				//console.log(json.errors);
				// throw new Error(json.errors);
			}
			
			return json;

		} catch (err) {
			loadError = "Failed to load individual invoices. ";
			if (err.message) loadError += err.message;
		} finally {
			isQueryComplete = true;
			Loader.hide();
		}
	};

	function displayResults(data) {
		if (data == undefined) return;
		individualInvoicesState.invoicesList = data.invoices != null ? data.invoices.map((d) => new IndividualInvoiceRecord(d)) : null;
	}

	function handleFilterDateChange(event) {
		function validateDateByKey(stateKey) {
			Reflect.deleteProperty(errors, stateKey);
			const invalidDateMessage = "Invalid Date";
			try {
				const dateFormatter = getDateFormatter();
				const rawValue = individualInvoicesState[stateKey];
				if (!rawValue) {
					errors[stateKey] = invalidDateMessage;
					return;
				}

				const date = new Date(rawValue);
				if (Number.isNaN(date.getTime())) {
					errors[stateKey] = invalidDateMessage;
					return;
				}

				const formatted = dateFormatter.format(date);
				if (!isValidDate(formatted)) {
					errors[stateKey] = invalidDateMessage;
				}
			} catch {
				errors[stateKey] = invalidDateMessage;
			}

			if (errors.beginningDate || (errors.endingDate && errors.endingDate === invalidDateMessage)) {
				return;
			}

			const endDate = new Date(individualInvoicesState.endingDate);
			const beginDate = new Date(individualInvoicesState.beginningDate);
			if (endDate < beginDate) {
				errors.endingDate = "Ending Date cannot be before Beginning Date.";
				return;
			} else {
				Reflect.deleteProperty(errors, "endingDate");
			}
		}

		const inputName = event.target.name;

		validateDateByKey(
			inputName === "EndingDate" ? "endingDate" : "beginningDate",
		);
		
		if (Object.keys(errors).length === 0) {
			doQuery().then((data) => displayResults(data));
		}
	}	

	function handleDownloadInvoice(event){
		//console.log("handle download invoice", data);
		event.preventDefault();
		var entryId = event.currentTarget.dataset.entryid;		
		var downloadUrl = baseUrl + "Options/IndividualInvoices/DownloadIndividualInvoice";
		const url = downloadUrl + "?entryId=" + encodeURIComponent(entryId);
		window.open(url, "_blank", "noopener,noreferrer");
	}

	const doQuery = debouncePromise(loadIndividualInvoices, 500);
	//const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

	onMount(async () => {
		//trigger initial load of individual invoices
		loadIndividualInvoices().then((data) => displayResults(data));

	});
</script>

<main>
	<div class="row mb-3">
		<div class="col-md-3 col-sm-3 col-xs-12">
			<FormGroup floating spacing="mb-3" label="Beginning Date">
				<Input
					placeholder="MM/DD/YYYY"
					name="BeginningDate"
					type="date"
					bind:value={individualInvoicesState.beginningDate}
					onchange={handleFilterDateChange}
					invalid={Boolean(errors.beginningDate)}
					feedback={errors.beginningDate}
				/>
			</FormGroup>
		</div>

		<div class="col-md-3 col-sm-3 col-xs-12">
			<FormGroup floating spacing="mb-3" label="Ending Date">
				<Input
					placeholder="MM/DD/YYYY"
					name="EndingDate"
					type="date"
					bind:value={individualInvoicesState.endingDate}
					onchange={handleFilterDateChange}
					invalid={Boolean(errors.endingDate)}
					feedback={errors.endingDate}
				/>
			</FormGroup>
		</div>
	</div>
	{#if loadError}
		<div class="row">
			<div class="col text-danger">{loadError}</div>
		</div>
	{/if}
	{#if isQueryComplete}
		<div>
		    <div class="no-print mt-3 mb-3">
				{#if individualInvoicesState.invoicesList != null && individualInvoicesState.invoicesList.length > 0}
		            <table class="table table-hover table-bordered table-striped mb-4">
		                <thead>
		                    <tr class="table-primary fw-bold">
		                        <td>Date Created</td>
		                        <td>Member Name</td>
		                        <td>View Invoice</td>
		                    </tr>
		                </thead>
		                <tbody>
							{#each individualInvoicesState.invoicesList as invoice}
		                        <tr>
		                            <td>{invoice.dateCreated}</td>
		                            <td>{invoice.memberName}</td>									
									<!-- svelte-ignore a11y_click_events_have_key_events, a11y_no_static_element_interactions, a11y_missing_attribute -->
									<td><a data-entryid="{invoice.entryId}" onclick={handleDownloadInvoice} aria-label="Download" class="hover-hand"><i class="pdf-lg"></i></a></td>
		                        </tr>
							{/each}
		                </tbody>
		            </table>
				{:else if individualInvoicesState.invoicesList == null}
		            <h4>Individual invoices cannot be retrieved at this time.</h4>
		    		<br />
				{:else}
		            <h4>You do not have any individual invoices for the currently selected beginning date and ending date.</h4>
		            <br />
				{/if}
		    </div>
		</div>
	{/if}
</main>